import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";

var FunctionTags =
/*#__PURE__*/
function (_Vue) {
  _inherits(FunctionTags, _Vue);

  function FunctionTags() {
    _classCallCheck(this, FunctionTags);

    return _possibleConstructorReturn(this, _getPrototypeOf(FunctionTags).apply(this, arguments));
  }

  return FunctionTags;
}(Vue);

tslib_1.__decorate([Prop({
  default: "free"
})], FunctionTags.prototype, "type", void 0);

FunctionTags = tslib_1.__decorate([Component({
  components: {}
})], FunctionTags);
export default FunctionTags;